import React from 'react';
import { connect } from 'react-redux';

import Textinput from './textinput';

import { cutDate } from '../services/utils';
import { getIndexByMaketIdRequestV2, addIndexRequest, updateIndexRequest, deleteIndexRequest } from '../services/api';
import { getMarketsList, getMarketIndicesDates } from '../selectors/indicesSelectors';

import { getProductsIndices } from '../actions/indicesActions';

const getMarketId = (id, indicesFrequency) => (id && indicesFrequency ? `${id}_${indicesFrequency}` : '');

class ManageIndexPopup extends React.Component {
    state = {
        data: [],
        noProducts: false,
    };

    componentDidMount() {
        const { market_id, selected_date, frequencyType } = this.props.indices;

        this.getIndices(market_id, selected_date, frequencyType);
    }

    componentDidUpdate(prevProps, prevState) {
        const { market_id: marketId, selected_date: selectedDate, frequencyType } = this.props.indices;
        const {
            market_id: prevMarketId,
            selected_date: prevSelectedDate,
            frequencyType: prevFrequencyType,
        } = prevProps.indices;

        if (marketId !== prevMarketId || selectedDate !== prevSelectedDate || frequencyType !== prevFrequencyType) {
            this.getIndices(marketId, selectedDate, frequencyType);
        }
    }

    getIndices = async (market_id, selected_date, frequencyType) => {
        if (!selected_date || !market_id) {
            return;
        }

        try {
            const result = await getIndexByMaketIdRequestV2(selected_date, market_id, frequencyType);

            this.setState({
                data: result.data,
                noProducts: false,
            });
        } catch (error) {
            this.setState({
                data: [],
                noProducts: true,
            });
        }
    };

    onChangeSelect = e => {
        const { year } = this.props.indices;
        const { marketsList } = this.props;
        const { name, value } = e.target;

        if (name === 'market_id') {
            const { id, frequency_type: frequency_type } = marketsList && marketsList.find(m => m.marketId === value);
            this.props.getProductsIndices(id, year, frequency_type);
        } else {
            this.props.setSelectedDate(value);
        }
    };

    onChangeInput = (e, i) => {
        const { value } = e.target;
        let newData = this.state.data;

        if (!('inital' in newData[i])) {
            newData[i].inital = newData[i].product_index;
        }

        newData[i].product_index = value;

        this.setState({
            data: newData,
        });
    };

    onSubmit = () => {
        let { data } = this.state;
        const { selected_date } = this.props.indices;
        const isNotEmpty = data.some(item => item.product_index);
        const requests = [];
        let params = {};
        let action;

        if (this.state.noProducts || !selected_date) {
            return this.props.hidePopup();
        }
        if (isNotEmpty) {
            this.props.showProgress();
            data.map((item, i) => {
                const { inital, product_index, product_id } = item;
                action = false;

                if (inital || inital === null || inital === 0) {
                    if (inital !== product_index && product_index !== '') action = 'update';
                    if (inital === null && product_index !== '') action = 'create';
                    if (inital !== null && product_index === '') action = 'delete';
                }

                if (action) {
                    params = {
                        created_date: selected_date,
                        product_id,
                        index: product_index,
                    };
                    requests.push(this.detectIndexRequest(action, params));
                }
            });

            Promise.all(requests)
                .then(values => {
                    this.props.hideProgress();
                    this.props.refresh();
                    this.props.hidePopup();
                })
                .catch(error => {
                    this.props.hideProgress();
                });
        }
    };

    detectIndexRequest = (action, params) => {
        if (action === 'create') {
            return addIndexRequest(params);
        }
        if (action === 'update') {
            return updateIndexRequest(params);
        }
        if (action === 'delete') {
            return deleteIndexRequest(params);
        }
    };

    closePopup = e => {
        if (e.target.getAttribute('name') === 'manageIndexPopup') this.props.hidePopup();
    };

    render() {
        const { data } = this.state;
        const { marketsList, dates } = this.props;
        const { market_id, selected_date, frequencyType } = this.props.indices;

        return (
            <div
                onClick={this.closePopup}
                style={{ display: this.props.visible ? 'block' : 'none' }}
                name="manageIndexPopup"
                className="admin-index-container generic-popup-container"
            >
                <div className="admin-index-inner">
                    <center>
                        <h1 className="title">
                            {selected_date ? `Indexdate: ${cutDate(selected_date)}` : 'Schedule is absent'}
                        </h1>
                    </center>

                    {selected_date ? (
                        <div className="field-wrap">
                            <label htmlFor="indexdate" className="labelactive">
                                Index date<span className="req">*</span>
                            </label>
                            <select name="selected_date" onChange={this.onChangeSelect} value={selected_date}>
                                {dates.map(day => (
                                    <option value={day} key={day}>
                                        {cutDate(day)}
                                    </option>
                                ))}
                            </select>
                        </div>
                    ) : null}

                    <div className="field-wrap">
                        <label htmlFor="market_id" className="labelactive">
                            Market<span className="req">*</span>
                        </label>
                        <select
                            name="market_id"
                            onChange={this.onChangeSelect}
                            value={getMarketId(market_id, frequencyType)}
                        >
                            {marketsList && marketsList.length
                                ? marketsList.map(item => (
                                      <option
                                          key={'markselpop_' + item.marketId}
                                          value={getMarketId(item.id, item.frequency_type)}
                                      >
                                          {item.name}
                                      </option>
                                  ))
                                : null}
                        </select>
                    </div>
                    {selected_date && data.length
                        ? data.map((item, i) => (
                              <div key={`popprod${item.product_id}`} className="double-column-holder">
                                  <div className="dc-col-1">
                                      <h3 className="product-name-limiter">
                                          {item.short_name} ({item.unit_name}, {item.contract_type})
                                      </h3>
                                  </div>
                                  <div className="dc-col-2">
                                      <Textinput
                                          name={`product_${item.product_id}`}
                                          value={this.state.data[i].product_index}
                                          onChange={event => this.onChangeInput(event, i)}
                                          invalid={false}
                                          maxLength={16}
                                          type="number"
                                      />
                                  </div>
                              </div>
                          ))
                        : null}

                    <button type="submit" onClick={this.onSubmit} className="button button-block">
                        {this.state.noProducts || !selected_date ? 'Close' : 'Update'}
                    </button>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        dates: getMarketIndicesDates(state),
        marketsList: getMarketsList(state),
    }),
    dispatch => ({
        getProductsIndices: (marketId, year, frequencyType) =>
            dispatch(getProductsIndices(marketId, year, frequencyType)),
    }),
)(ManageIndexPopup);



// WEBPACK FOOTER //
// ./source/components/indexPopup.js